import { MdSearch } from "react-icons/md";

export default function Filter({ filter, setFilter }) {
  return (
    <div className="col-md-12 mt-4 mb-4">
      <div className="d-flex justify-content-center">
        <div className="input-group" style={{ width: "320px" }}>
          <span
            className="input-group-text font-bold text-secondary"
            style={{ fontSize: "18px" }}
          >
            <MdSearch size={24} />
          </span>
          <input
            type="text"
            className="form-control"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Search..."
          />
        </div>
      </div>
    </div>
  );
}
